import React from 'react';
import { Row } from 'react-bootstrap';
import {
  InputAsyncSelect,
  InputPeso,
  InputText,
} from '~/components/NovosInputs';
import { moedaFormatada } from '~/components/NovosInputs/InputMoney/formatMask';
import Separator from '~/components/Separator';
import ToggleDefault from '~/components/ToggleDefault';
import { transformAsCurrency } from '~/utils/functions';
import { useAjusteDeEstoque } from '../../hooks/useAjusteDeEstoque';
import { renderizarUnidade } from '../../utils/renderizarUnidade';

export const FormAjuste: React.FC = () => {
  const {
    formTela: {
      register,
      control,
      setValue,
      watch,
      formState: { errors },
      clearErrors,
    },
    isUpdate,
    produto,
    qtdAlteracao,
    estPosterior,
    tipoUnidadeAjuste,
    isDisabled,
    isDisableSearch,
    watchManterDados,
    ajusteRef,
    setTipoUnidadeAjuste,
    handleTipoAjuste,
    handleNumDocumento,
    handleQtdAlteracao,
    handleEstoquePosterior,
    focus,
  } = useAjusteDeEstoque();

  const flgCancelado = watch('flg_cancelado');

  return (
    <>
      <div className="col-12">
        <Separator labelText="Dados do Ajuste" />
      </div>
      <div className="col-sm-12 col-md-7" ref={ajusteRef}>
        <InputAsyncSelect
          label="Tipo de Ajuste *"
          placeholder="Selecione o tipo de ajuste"
          name="ajuste"
          id="ajuste"
          register={register}
          isError={!!errors.ajuste}
          control={control}
          disabled={isUpdate}
          changeSelected={(selected: any) => {
            handleTipoAjuste(selected);
            setTipoUnidadeAjuste(selected.tipo_unidade);
            focus('qtd_alteracao');
            setValue('ajuste', selected);
          }}
          api={{
            route: '/ajuste',
            method: 'get',
            fields: ['cod_tipo_ajuste', 'des_operacao', 'des_ajuste'],
            searchBeforeFilter: true,
          }}
          maxLength={50}
        />
      </div>
      <div className="col-sm-12 col-md-3">
        <InputText
          label="Docto"
          name="num_documento"
          maxLength={45}
          caseInput="upper"
          placeholder="Informe o número do documento"
          isDisabled={isUpdate}
          isError={!!errors.num_documento}
          control={control}
          register={register}
          onInput={(ev: any) => {
            const { value } = ev.target;
            handleNumDocumento(value);
          }}
        />
      </div>
      {!isUpdate && (
        <div
          className="col-sm-12 col-md-1 text-nowrap"
          style={{ marginTop: '10px' }}
        >
          <ToggleDefault
            labelText="Manter Dados?"
            onSwitch={() => setValue('manterDados', !watchManterDados)}
            setChecked={watchManterDados}
          />
        </div>
      )}
      <Row>
        <div className="col-sm-12 col-md-2">
          {produto && (
            <InputPeso
              label="Quantidade Alteração *"
              maxLength={15}
              step={produto?.flg_ipv ? '.01' : '1'}
              max={1000000000}
              min={0}
              value={qtdAlteracao}
              decimals={3}
              placeholder="0"
              disabled={isDisabled}
              name="qtd_alteracao"
              register={register}
              control={control}
              isError={!!errors.qtd_alteracao}
              onFocus={(event) => event.target.select()}
              onChange={(event: any) => {
                const { value } = event.target;
                clearErrors('qtd_alteracao');
                if (produto?.flg_ipv) {
                  const quantidadeAlteracao = transformAsCurrency(
                    moedaFormatada(value, 3),
                  );
                  handleQtdAlteracao(quantidadeAlteracao);
                } else {
                  const serializedValue = String(value).replace(/\D/g, '');
                  handleQtdAlteracao(serializedValue);
                }
              }}
              style={{ marginRight: '-1px', textAlign: 'right' }}
            />
          )}
        </div>
        <div className="col-sm-12 col-md-2">
          {produto && (
            <InputPeso
              label="Estoque Posterior"
              maxLength={15}
              step={produto?.flg_ipv ? '.01' : '1'}
              max={1000000000}
              min={1}
              value={estPosterior}
              decimals={3}
              placeholder="0"
              id="qtd_posterior"
              disabled={isDisabled}
              name="qtd_posterior"
              register={register}
              control={control}
              onChange={(event: any) => {
                const { value } = event.target;
                if (produto?.flg_ipv) {
                  const estoquePosteriorFormatado = transformAsCurrency(
                    moedaFormatada(value, 3),
                  );
                  handleEstoquePosterior(estoquePosteriorFormatado);
                } else {
                  const serializedValue = String(value).replace(
                    /[a-zA-Z,;.@#!$%¨&*()+={}'"/^_]/g,
                    '',
                  );
                  handleEstoquePosterior(serializedValue);
                }
              }}
              onFocus={(event) => {
                event.target.select();
              }}
              isError={!!errors.qtd_posterior}
            />
          )}
        </div>
        <div className="col-sm-12 col-md-2 d-flex align-items-end">
          <p className="qtdCaixa">
            {isDisableSearch &&
              tipoUnidadeAjuste !== undefined &&
              renderizarUnidade(
                produto,
                tipoUnidadeAjuste === 0
                  ? 'des_unidade_venda'
                  : 'des_unidade_compra',
                tipoUnidadeAjuste === 0
                  ? 'qtd_embalagem_venda'
                  : 'qtd_embalagem_compra',
              )}
          </p>
          {flgCancelado && (
            <div className="col-sm-12 col-md-2 cancelado">
              <h2>CANCELADO</h2>
            </div>
          )}
        </div>
      </Row>
    </>
  );
};
